import styled from 'styled-components'

import { theme } from 'styles/theme'

import { fluidType } from '../fluid-type'

const { colors, media, radii, space } = theme

export { Section } from 'components/general-styles/General'

export const TitleWrapper = styled.div`
  margin-top: ${space['spacing-xl']};

  h2,
  h2 span {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    letter-spacing: -0.02em;
  }
`

export const Lead = styled.div`
  margin-top: ${space['spacing-xl']};

  p {
    margin: 0;
  }

  @media (${media.desktop}) {
    margin-top: 3.125rem;
  }
`

export const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['spacing-md']};
  margin-top: ${space['spacing-xl']};

  @media (${media.phone}) {
    gap: 0;
  }

  @media (${media.tablet}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (${media.desktop}) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 0.625rem;
    margin-top: 3.125rem;
  }
`

export const Card = styled.article<{ $order: number }>`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xl']};
  padding: ${space['spacing-xl']} 1.875rem;
  overflow: hidden;
  background-color: ${colors['blue-background-strong-default']};

  /* 20px do desenho: a escala de raio pula de 16px para 24px. */
  border-radius: 1.25rem;

  p {
    margin: 0;
  }

  @media (${media.phone}) {
    position: sticky;
    top: calc(${space['spacing-md']} + ${({ $order }) => $order * 4.5}rem);
    z-index: ${({ $order }) => $order + 1};
    gap: ${space['spacing-sm']};
    min-height: 206px;
    padding: ${space['spacing-md']};
    border-top: 1px solid ${colors['cyan-background-pressed']};
    border-radius: 30px;

    &:not(:first-child) {
      margin-top: -${space['spacing-sm']};
    }
  }
`

export const IconWrapper = styled.span`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  justify-content: center;
  width: 2.875rem;
  height: 2.875rem;
  border: 1px solid ${colors['cyan-background-pressed']};
  border-radius: ${radii['corner-radius-sm']};

  img {
    width: ${space['spacing-md']};
    height: ${space['spacing-md']};
  }
`
